import { createSelector } from 'reselect';
import { fastShippingCopySignedOutSelector } from 'selectors/testTarget/offers/fastShippingCopySignedOut/fastShippingCopySignedOutSelector';

const showSelector = createSelector(fastShippingCopySignedOutSelector, fastShippingCopySignedOut => !!fastShippingCopySignedOut.show);

export { showSelector };
